import { PaymentStatus } from '@ca/common'
import Status from '@ui/elements/Status'
import { StatusVariant } from '@ui/elements/Status/types'
import { useTranslation } from 'react-i18next'

const paymentStatusVariant: Record<PaymentStatus, StatusVariant> = {
  completed: 'success',
  initialized: 'neutral',
  draft: 'neutral',
  waiting: 'warning',
  error: 'danger',
}

const PaymentStatusBadge = ({ status }: { status: PaymentStatus }) => {
  const { t } = useTranslation(['status'])

  return (
    <Status
      text={t(`status:payment.new.${status}.long`)}
      size="default"
      variant={paymentStatusVariant[status]}
    />
  )
}

export default PaymentStatusBadge
